<div class="file-drop-wrapper" [ngClass]="{'file-over': isFileOver}">
  <input id="file-input" name="fileInput" type="file" (change)="onFileChange($event)" hidden>
  <div class="info text-center">
    <div class="upload-ico"></div>
    <div><span class="mtv-primary-color">{{hint}}</span></div>
    <div *ngIf="supportedFileTypes.length"><span class="small">Supported formats: {{supportedFileTypes.join(', ')}}</span></div>
  </div>
  <label fileDrop for="file-input" class="file-drop" (onFileDrop)="onFileDrop($event)" (fileOver)="fileOver($event)"></label>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/file-upload/file-upload.component.html